<template>
    <div class="header-msg f-18">
        <div class="header-style d-flex item-center">
            <dv-decoration-1 class="flip-horizontal" style="width:40px;height:30px;" />
            <div class="fw-800">{{ msg }}</div>
        </div>
    </div>
</template>

<script>
export default {
    name: '',
    props: ['msg'],
    data() {
        return {
        }
    }
}
</script>

<style lang="less" scoped>
.header-msg{
    .header-style{
        height: 50px;
        width: 96%;
        color: rgb(255, 255, 255, 1);
        background: rgba(36, 42, 60, 1);
        .title-before{
            width: 8px;
            height: 40px;
            background: rgba(238, 144, 59, 1);
            margin-left: 2px;
            margin-right: 10px;
        }
        .right-select{
            margin-right: 12px;
        }
        .right-icon{
            margin-left: auto;
        }
    }
}
</style>
